import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	dateRange: {
		id: 'eoc-schedule.common.ui.date-navigation.date-range',
		defaultMessage: '{startMonthShort} {startDayNumeric} - {endMonthShort} {endDayNumeric}',
		description: 'Shown date range in schedule. (e.g. Nov 14 - Nov 28)',
	},
	dateSingle: {
		id: 'eoc-schedule.common.ui.date-navigation.date-single',
		defaultMessage: '{weekDayLong}, {monthShort} {dayNumeric}',
		description: 'Shown single date in schedule. (e.g. Tuesday, Nov 15)',
	},
	dateCalendar: {
		id: 'eoc-schedule.common.ui.date-navigation.date-calendar',
		defaultMessage: '{monthLong} {yearLong}',
		description: 'Shown date in schedule for calendar view. (e.g. February 2023)',
	},
});
